import { usageTypes } from "./constants";

export const getUsageTypeOptions = (resources) => {
    return usageTypes.map((type) => ({
        key: type.key,
        name: resources[type.name],
    }));
};